module.exports = __webpack_public_path__ + "img/mocha.5d8c61d4.png";